t = require('views/internal/teacup-with-helpers')('plugin_alert')

module.exports = t.renderable ({ icon, message, name }) ->
  t.div '.plugin-alert', ->
    t.img '.plugin-alert-icon', { src: icon }
    t.div '.plugin-alert-content', ->
      t.div '.plugin-alert-header', ->
        t.span '.plugin-alert-name', name
        t.a '.alert-dismiss.js-dismiss-alert.icon-sm.icon-close', { href: '#' }
      t.span '.plugin-alert-msg', message



// WEBPACK FOOTER //
// ./app/scripts/views/templates/plugin_alert.coffee